export default __webpack_public_path__ + "images/default.png?455d1d7dbfa5e0a3e6b3ed4407384f37";